import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '& div, & a': {
        marginRight: SMALL_MARGIN,
        '&:last-child': {
          marginRight: 0,
        },
        [theme.breakpoints.up('sm')]: {
          marginRight: MIDDLE_MARGIN,
        },
      },
    },
  }),
);

export default useStyles;
